import React from 'react';
import styles from '../AddRateModal.module.scss';
import {useTranslation} from 'react-i18next';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {useStylesBox} from './styleCustom';

interface TitleSelectProps {
    selectValue: {[key: string]: string};
    setAddObj: React.Dispatch<React.SetStateAction<any>>;
};

const selectMapping: any = [
    {
        key: 'instagram',
        name: 'Instagram',
      },
      {
        key: 'twitter',
        name: 'Twitter',
      },
      {
        key: 'youtube',
        name: 'YouTube',
      },
      {
        key: 'tiktok',
        name: 'Tik Tok',
      },
      {
        key: 'snapchat',
        name: 'Snapchat',
      },
      {
        key: 'linkedin',
        name: 'LinkedIn',
      },
    ];

const PlatformSelector = ({selectValue, setAddObj}: TitleSelectProps) => {
    const {t} = useTranslation();
    const classesInput = useStylesBox();

    return (
        <div className={`${styles.rowBox} ${styles.fullwidth}`}>
            <div className={styles.rowTop} style={{display: 'flex'}}>
                <div dir="ltr" className={`${styles.dropdown} ${styles.input} ${styles.clicked}`}>
                    <Select
                        labelId="social-platform-selector"
                        id="social-platform-selector"
                        style={{width: '100%', height: '56px', padding: '6px 10px', marginRight: '0.2rem', fontSize: '16px', fontWeight: 400, background: 'white', borderRadius: '26px', borderBottom: '1px solid rgba(217, 217, 217, 0.6)'}}
                        value={selectMapping.filter((e: any) => e.key == selectValue?.platform)[0].key}
                        className={classesInput.textField}
                        onChange={(e: any) => {
                            setAddObj({...selectValue, platform: e.target.value, contentType: ''});
                        }
                        }
                    >
                        {selectMapping.map((ele: any) => <MenuItem key={`social-name-${ele.key}`} value={ele.key}>{ele.name}</MenuItem>)}
                    </Select>
                </div>
            </div>
        </div>
    );
};

export default PlatformSelector;
